import { LIST_ITEMS_PAGE_SIZE } from '®shared/reading-list/models/pageable-items';

export type PageableItemsErrorWithOffset<E> = {
  error: E;
  offset: number;
};

export function getPageableItemsErrorWithOffset<T>(
  error: T,
  offset: number,
): PageableItemsErrorWithOffset<T> {
  return { error, offset };
}

export function getPageOffsetFromError<T>(
  error: PageableItemsErrorWithOffset<T>,
): number {
  return error.offset;
}

export function getPageOffsets(
  totalItems: number,
  pageSize = LIST_ITEMS_PAGE_SIZE,
): number[] {
  const pageCount = getTotalPages(totalItems, pageSize);
  return Array.from(
    { length: pageCount },
    (_, pageNumber) => pageNumber * pageSize,
  );
}

export function getTotalPages(
  totalItems: number,
  pageSize = LIST_ITEMS_PAGE_SIZE,
): number {
  const totalPages = Math.ceil(totalItems / pageSize);
  return totalPages === 0 ? 1 : totalPages;
}
